import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingComponent = () => {
  return (
    <div>
      <CircularProgress size={24} />
      <p className={'mt-2 mb-0'}>Loading...</p>
    </div>
  );
};

export default LoadingComponent;
